import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Marcelo R.',
  location: 'San Justo, Buenos Aires',
  pack: 'Pack CI 6×6 + Gestión Profesional',
  quote: 'Fui al corralón con el cómputo del Tomo 5 y salí sin sorpresas. El albañil no podía creer que yo supiera exactamente qué pedir y en qué cantidad.'
}, {
  initials: 'DF',
  name: 'Daniela y Facundo',
  location: 'Moreno, Buenos Aires',
  pack: 'Pack CI 6×6',
  quote: 'Teníamos el terreno hace tres años. Con el Tomo 1 entendimos que podíamos empezar con 35m² y crecer en etapas. Hoy estamos en el Tomo 3 — 72m² con dos baños — y sin haber demolido ni una pared.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Córdoba Capital',
  pack: 'Pack CI 6×6 + Gestión Profesional',
  quote: 'Contraté al albañil con el contrato del Acelerador y por primera vez la obra terminó en tiempo y en presupuesto. Literalmente. No hubo sorpresas porque todo estaba por escrito desde el principio.'
}, {
  initials: 'VC',
  name: 'Valeria C.',
  location: 'Quilmes, Buenos Aires',
  pack: 'Pack CI 6×6',
  quote: 'El Layout Perfecto me salvó de un error enorme. Cambié la distribución antes de construir — si no lo descubría ahí, lo pagaba en la obra.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Rosario, Santa Fe',
  pack: 'Pack CI 6×6 + Gestión Profesional',
  quote: 'El flujo de caja semanal fue un antes y un después. Por primera vez supe exactamente cuánto llevaba gastado y cuánto me quedaba para terminar — semana a semana.'
}];
export function ExtendedTestimonials() {
  return <section className="py-20 bg-white" data-id="element-95">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-bold flex items-center justify-center gap-3" data-id="element-98">
            ❤️ MÁS PROPIETARIOS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="space-y-6" data-id="element-99">
          {testimonials.map((t, i) => <div key={i} className="bg-beige rounded-xl p-6 md:p-8 border border-beige-dark shadow-sm" data-id="element-100">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-101">
                <div className="flex items-center gap-4 md:w-1/3 shrink-0" data-id="element-102">
                  <div className="w-14 h-14 rounded-full bg-charcoal text-white flex items-center justify-center font-serif font-bold text-xl" data-id="element-103">
                    {t.initials}
                  </div>
                  <div data-id="element-104">
                    <div className="flex text-gold mb-1" data-id="element-105">
                      {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-106" />)}
                    </div>
                    <p className="font-bold text-charcoal" data-id="element-107">{t.name}</p>
                    <p className="text-sm text-gray-500 flex items-center gap-1" data-id="element-108">
                      📍 {t.location}
                    </p>
                  </div>
                </div>

                <div className="md:w-2/3" data-id="element-109">
                  <div className="inline-block bg-white px-3 py-1 rounded-md text-sm font-semibold text-gold border border-gold/20 mb-3" data-id="element-110">
                    {t.pack}
                  </div>
                  <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-111">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}